import { render, staticRenderFns } from "./MessageSend.vue?vue&type=template&id=011a1b33"
import script from "./MessageSend.vue?vue&type=script&lang=js"
export * from "./MessageSend.vue?vue&type=script&lang=js"
import style0 from "./MessageSend.vue?vue&type=style&index=0&id=011a1b33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports